import toastr from "toastr";

const toastrNotificationOptions = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "3000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};

const defaultToastrNotificationOptions = {
    positionClass: "default-toast",
    showDuration: "300",
    hideDuration: "500",
    timeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};

export const showInfoNotification = function (
    notificationDetails,
    notificationHeader
) {
    toastr.options = toastrNotificationOptions;
    toastr.info(notificationHeader, notificationDetails);
};

export const showSuccessNotification = function (
    notificationDetails,
    notificationHeader,
    smallWidthToast
) {
    toastr.options = toastrNotificationOptions;
    if (smallWidthToast) {
        toastr
            .success(notificationDetails, notificationHeader)
            .css("width", "175px");
    } else {
        toastr.success(notificationDetails, notificationHeader);
    }
};

export const showErrorNotification = function (
    notificationDetails,
    notificationHeader,
    toastTimeout
) {
    toastr.options = toastrNotificationOptions;
    if (toastTimeout) {
        toastr.options.timeOut = toastTimeout;
    }
    toastr.error(notificationDetails, notificationHeader);
};

export const showDefaultSuccessNotification = function (
    notificationDetails = "Success"
) {
    toastr.options = defaultToastrNotificationOptions;
    toastr.success(notificationDetails);
};

export const showDefaultErrorNotification = function (
    notificationDetails = "Error"
) {
    toastr.options = defaultToastrNotificationOptions;
    toastr.error(notificationDetails);
};
